export interface IThrottleController {
  run(callback: () => void): void;
  cancel(): void;
}

export function createThrottle(timeoutMs: number): IThrottleController {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let pendingCallback: (() => void) | null = null;

  return {
    run(callback: () => void) {
      if (timeoutId) {
        pendingCallback = callback;
        return;
      }

      callback();

      timeoutId = setTimeout(() => {
        timeoutId = null;
        if (pendingCallback) {
          const next = pendingCallback;
          pendingCallback = null;

          this.run(next);
        }
      }, timeoutMs);
    },
    cancel() {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    },
  };
}
